
import React, { ReactElement, useEffect, useState } from 'react';
import i18next from 'i18next';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { setUserLanguage } from '../../views/user/user.reducer';
import { connect, useDispatch } from 'react-redux';
import { IntLanguageProps } from '../../schemas/language.interface';
import { IntStore } from '../../schemas/store.interface';
import LanguageElement from '../../components/ui/language-element/language-element';
import { setUserLang, getUserLang } from '../../core/session-storage/session-storage.service';
import { setListLanguages, setView } from '../../core/masterdata/masterdata.reducer';
import { hideLoading, showLoading } from '../../components/ui/loading/loading.reducer';
import {getLanguageList} from './language-list.service'
import { getImages } from '../../utils/const';


const LanguageList = (props: IntLanguageProps): ReactElement => {

  const dispatch = useDispatch()
  const { t } = useTranslation();
  const history = useHistory();
  const [dataLanguage , setDataLanguage] = useState([]);

  const [displayLanguage, setDisplayLanguage] = useState(false);
  const [idLang, setidLang] = useState(getUserLang());
  const [idLanguage, setidLanguage] = useState('');


  useEffect(() => {
    async function load() {
      props.showLoading();
      const languague = await props.getLanguageList(history);

      if(!languague || !languague.length){
        return;
      }

      const lang = languague.find((lang:any) => lang.code === idLang);
      if (lang?.name)
        setidLanguage(lang.name);
      else
        setidLanguage('es-ES');
      dispatch(setListLanguages(languague))
      setDataLanguage(languague);
    }
    load();
  }, []);


  const handleSelectLanguage = (name: string, idLang?: any) => {
    props.setUserLanguage(idLang);
    setUserLang(idLang); // Para actualización de userLang en Footer
    i18next.changeLanguage(idLang).then((t) => {

      setUserLang(idLang);
      setidLang(idLang)
      props.hideLoading();
      setDisplayLanguage(false);
      setidLanguage(name);
    });
  };

  // WCAG 2.1.2: la lista desplegada debe poder cerrarse con teclado.
  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Escape' || event.key === 'Esc') {
      setDisplayLanguage(false);
    }
  };




  return (
    <div className="">
      <div data-testid="languageList">

            {/* WCAG 2.1.1 / 4.1.2: disparador nativo con estado expandido. */}
            <button
              type="button"
              className="language-header"
              aria-expanded={displayLanguage}
              aria-haspopup="true"
              onClick={() => setDisplayLanguage(!displayLanguage)}
            >
              <img className="language-flag" src={getImages(idLang)} alt="" />
              <span className="sr-only">{t('A11Y_IDIOMA')}</span>
              <span className="language-country">{idLanguage}</span>
            </button>

            {/* WCAG 2.1.2: la lista se cierra con Escape y devuelve el foco. */}
            <div className="list--container" onKeyDown={handleKeyDown}>
                {dataLanguage && dataLanguage.length && displayLanguage &&
                 dataLanguage.map((item:any, index) => (
                  <LanguageElement
                    key={index + '-'+ item.code}
                    idLang={item.code}
                    label={item.name}
                    isSelected={item.code === idLang}
                    handleSelectLanguage={(idLang: any) => handleSelectLanguage(item.name, idLang)}
                  />
              ))}
            </div>

      </div>
    </div>

  );
};

const mapStateToProps = (state: IntStore) => {
  return {
    user: state.user,
  };
};

const mapDispatchToProps = {
  setUserLanguage,
  setView,
  hideLoading,
  showLoading,
  getLanguageList
};

export default connect(mapStateToProps, mapDispatchToProps)(LanguageList);
